import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

export default function FireSafetyDashboardTables() {
  // Data for Fire Safety Compliance by Category
  const categoryData = [
    { category: 'Fire Extinguishers', total: 12, compliant: 11, actionDue: 1, overdue: 0, na: 0 },
    { category: 'Fire Alarms', total: 6, compliant: 5, actionDue: 0, overdue: 1, na: 0 },
    { category: 'Emergency Lighting', total: 6, compliant: 6, actionDue: 0, overdue: 0, na: 0 },
    { category: 'Fire Doors', total: 8, compliant: 7, actionDue: 1, overdue: 0, na: 0 },
    { category: 'Fire Safety Signage', total: 4, compliant: 4, actionDue: 0, overdue: 0, na: 0 },
    { category: 'Fire Blankets', total: 2, compliant: 2, actionDue: 0, overdue: 0, na: 0 },
  ];

  // Data for Fire Safety Testing & Checks
  const testingData = [
    { type: 'Weekly Fire Alarm Test', frequency: 'Weekly', lastCompleted: '18 Jul 2026', nextDue: '25 Jul 2026', status: 'Up to date' },
    { type: 'Emergency Lighting Test', frequency: 'Monthly', lastCompleted: '10 Jul 2026', nextDue: '10 Aug 2026', status: 'Up to date' },
    { type: 'Fire Extinguisher Inspection', frequency: 'Monthly', lastCompleted: '12 Jul 2026', nextDue: '12 Aug 2026', status: 'Up to date' },
    { type: 'Fire Door Inspection', frequency: 'Quarterly', lastCompleted: '01 Jun 2026', nextDue: '01 Sep 2026', status: 'Up to date' },
    { type: 'Fire Risk Assessment Review', frequency: 'Annually', lastCompleted: '18 Mar 2026', nextDue: '18 Mar 2027', status: 'Up to date' },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 max-w-[1800px] mx-auto items-stretch">
        
        {/* Left Card: Fire Safety Compliance by Category */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-sm font-bold text-indigo-950 mb-5">
              Fire Safety Compliance by Category
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[32%]">CATEGORY</th>
                    <th className="p-3 text-center">TOTAL</th>
                    <th className="p-3 text-center">COMPLIANT</th>
                    <th className="p-3 text-center">ACTION DUE</th>
                    <th className="p-3 text-center">OVERDUE</th>
                    <th className="p-3 text-center rounded-r-lg">NOT APPLICABLE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-bold text-slate-700 divide-y divide-slate-100">
                  {categoryData.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-3 text-slate-800 font-extrabold">{row.category}</td>
                      <td className="p-3 text-center text-slate-900 font-extrabold">{row.total}</td>
                      <td className={`p-3 text-center ${row.compliant > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.compliant}</td>
                      <td className={`p-3 text-center ${row.actionDue > 0 ? 'text-orange-400' : 'text-slate-400'}`}>{row.actionDue}</td>
                      <td className={`p-3 text-center ${row.overdue > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.overdue}</td>
                      <td className="p-3 text-center text-indigo-950/80">{row.na}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1 w-full text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View full fire safety register</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Right Card: Fire Safety Testing & Checks */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-sm font-bold text-indigo-950 mb-5">
              Fire Safety Testing & Checks
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[35%]">CHECK / TEST TYPE</th>
                    <th className="p-3">FREQUENCY</th>
                    <th className="p-3">LAST COMPLETED</th>
                    <th className="p-3">NEXT DUE</th>
                    <th className="p-3 text-center rounded-r-lg">STATUS</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-bold text-slate-700 divide-y divide-slate-100">
                  {testingData.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-3 text-slate-800 font-extrabold">{row.type}</td>
                      <td className="p-3 text-slate-500 font-medium">{row.frequency}</td>
                      <td className="p-3 text-slate-900 font-medium">{row.lastCompleted}</td>
                      <td className="p-3 text-slate-900 font-medium">{row.nextDue}</td>
                      <td className="p-3 text-center">
                        <span className="inline-block px-2 py-0.5 bg-emerald-50 text-emerald-600 text-[10px] font-extrabold border border-emerald-100 rounded-md whitespace-nowrap">
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1 w-full text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View all tests & checks</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
